import stores from 'cd-eft/models/Stores';
import { DynamicWaterwayHub } from './DynamicWaterwayHub';
import { DynamicTableStoreBase } from '../DynamicTableStoreBase';
import { ProfileKeyCode } from '../DynamicProfileEnums';
import { XyzPoint } from 'cd-eft/models/SurveyEngineering/XyzPoint';
import { WaterwayDesignToolsController, ProfileController } from 'cd-eft/services/eftSetApi';
import { AppConstants } from 'cd-eft/appConstants';
import { IWaterwayVertexParamDTO, convertStationBasedOnWaterwayVertexParamDTO } from 'cd-eft/models/Stores/WaterwayDesignStore';
import { DynamicWaterwayProfileStore } from './DynamicWaterwayProfileStore';
import { WaterwayDesignVM } from 'cd-eft/components/Design/Waterway/WDTContainer/WDTContentComp/WaterwayDesign/WaterwayDesignVM';
import { formatStationString } from 'cd-eft/utils/stationUtilities';


const designController = WaterwayDesignToolsController;
const { designStore, waterwayDesignStore } = stores.AppStore
class DynamicWaterwayTableStore extends DynamicTableStoreBase {
  protected hub: DynamicWaterwayHub;


  private _initialWaterwayDesignStation;

  protected _highlitedRows: string[] = [];


  // ai design
  humanFeedbackData: { nodeId: number; distanceAdjustment: number; elevationAdjustment: number }[] = [];
  /**
   *
   */
  constructor(hub: DynamicWaterwayHub) {
    super();

    this.hub = hub;
    this.profileKeys = [ProfileKeyCode.WCL, ProfileKeyCode.WLB, ProfileKeyCode.WRB, ProfileKeyCode.WLTB];
  }

  // adapt to global stores
  set setStore(setStore) {
    this.hub.setStore = setStore;
  }

  get setStore() {
    return this.hub.setStore;
  }

  public set waterwayStore(store) {
    this.hub.waterwayStore = store;
  }

  public get waterwayStore() {
    return this.hub.waterwayStore;
  }

  public highlightRows(i: number) {
    let id = `key-waterwayDesignStation-c-${i}`;
    if (!this._highlitedRows.some(r => r === id)) {
      this.tryHighlight(id);
      this._highlitedRows.push(id);
    }
    id = `key-waterwayDesignStation-s-${i}`;
    if (!this._highlitedRows.some(r => r === id)) {
      this.tryHighlight(id);
      this._highlitedRows.push(id);
    }
    id = `key-waterwayDesignStation-rv-${i - 1}`;
    if (!this._highlitedRows.some(r => r === id)) {
      this.tryHighlight(id);
      this._highlitedRows.push(id);
    }
  }

  public clearHighlights() {
    for (const row of this._highlitedRows) {
      this.tryHighlight(row, false);
    }
    this._highlitedRows = [];
  }

  protected tryHighlight(id: string, highlight: boolean = true) {
    const element = document.getElementById(id);
    if (element) {
      if (highlight) {
        element.classList.add("highlighted-row");
      } else {
        element.classList.remove("highlighted-row");
      }
    }
  }

  public checkSlopeDirection(stations: any[]) {
    const startStation = stations.find(station => station.reachId === "START");
    const r0Station = stations.find(station => station.reachId === "R-0");
    const endStation = stations.find(station => station.reachId === "END");
    const aboveEndStation = endStation ? stations[stations.indexOf(endStation) - 1] : null;

    const startChannelZ = startStation ? startStation.channelZ : null;
    const r0ChannelZ = r0Station ? r0Station.channelZ : null;
    const endChannelZ = endStation ? endStation.channelZ : null;
    const aboveEndChannelZ = aboveEndStation ? aboveEndStation.channelZ : null;

    if (startChannelZ !== null && r0ChannelZ !== null) {
      waterwayDesignStore.startGradeNegative = startChannelZ < r0ChannelZ;
    }

    if (endChannelZ !== null && aboveEndChannelZ !== null) {
      waterwayDesignStore.endGradeNegative = endChannelZ > aboveEndChannelZ;
    }
  }

  private get initialWaterwayDesignStation() {
    if (!this._initialWaterwayDesignStation) {
      //this._initialWaterwayDesignStation = this.setStore.initialWaterwayDesignStation;
      this._initialWaterwayDesignStation = waterwayDesignStore.initialWaterwayDesignStation;
    }
    return this._initialWaterwayDesignStation;
  }

  /** abstract method implementation */
  protected reset() {
    if (this.currentObject) {
      this.currentObject.waterwayDesignStations.length = 0;
      // const newRow = { ...this.initialWaterwayDesignStation };
      // this.currentObject.waterwayDesignStations.push(newRow);

      // this.currentObject.alignmentEntryMethod = 'Coordinates';
    }
  }

  protected insertRow(newVertex: any, vertexIndex: any) { }

  protected addRow(vertex: XyzPoint, state: string, vertexIndex: number) { }

  protected calculateStationDistances(indexToDelete?: number) { }

  protected async addRows(stationsData: any) {
    designStore.setLoader('Loading profile reaches...');
    const alignedElementDesignParamsId = Number(waterwayDesignStore.alignedDesignElementId);
    const stationVertices = {};
    stationsData.forEach((point) => {
      stationVertices[point[0]] = point[1] / (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor);
    });
    const data = (await designController.createDefaultReachesUsingPOST({ alignedElementDesignParamsId, stationVertices })).data;

    // if (data.status === 'wdt_124') {
    //     await MessageCenter.addErrorFromCode('WDT_124');
    // } else if (data.status === 'wdt_123') {
    //     await MessageCenter.addWarningFromCode('WDT_123');
    // }
    // const stations = this.currentObject.waterwayDesignStations;
    const stations = [{ ...this.initialWaterwayDesignStation }];
    // let startGuardrail = 0;
    // let endGuardrail = 0;
    if (data.waterwayVertexParamDTOList) {
      data.waterwayVertexParamDTOList.forEach((point, idx) => {
        const newRow = { ...this.initialWaterwayDesignStation, ...point };

        if (point.reachId !== 'START' && point.reachId !== 'END' && point.reachId !== 'R-0') {
          newRow.status = 'IN PROGRESS'
        } else {
          newRow.status = point.status
          // if (point.reachId == 'START') {
          //   startGuardrail = Number(point.endStation?.replace('+', ''));
          // };
          // if (point.reachId == 'END') {
          //   endGuardrail = Number(point.endStation?.replace('+', ''));
          // };

        }

        newRow.reachId = point.reachId ? point.reachId : '';
        if (point.startStation) {
          const index = point.startStation.indexOf('.');
          // newRow.startStation = index >= 0 ? point.startStation.slice(0, index) : point.startStation;
          newRow.startStation = point.startStation;
        } else {
          newRow.startStation = '';
        }
        if (point.endStation) {
          const index = point.endStation.indexOf('.');
          // newRow.endStation = index >= 0 ? point.endStation.slice(0, index) : point.endStation;
          // newRow.station = index >= 0 ? point.endStation.slice(0, index) : point.endStation;
          newRow.endStation = point.endStation;
          newRow.station = point.endStation;

          // const distance = point.endStation.replace('+', '');
          // let roundedDistance: number;
          // if (idx == 1) {
          //   roundedDistance = Math.ceil(Number(distance));
          // } else if (idx = data.waterwayVertexParamDTOList?.length! - 2) {
          //   roundedDistance = Math.floor(Number(distance));
          // } else {
          //   roundedDistance = Math.round(Number(distance));
          // }
          // const station = (Math.floor(roundedDistance / 100)).toFixed(0) + '+' + roundedDistance.toString().slice(-2);
          // newRow.endStation = station;
          // newRow.station = station;
        } else {
          newRow.endStation = '';
          newRow.station = '';
        }
        newRow.groundZ = Number(point.groundElev).toFixed(1);
        newRow.channelZ = Number(point.channelElev).toFixed(1);
        newRow.cutFill = Number(point.cutFill).toFixed(1);
        newRow.stationLength = Number(point.stationDist);
        if (point.reachId === 'START' || point.reachId === 'END') {
          newRow.grade = point.grade !== undefined ? (point.grade * 100).toFixed(2) : point.grade;
        } else {
          newRow.grade = point.grade;
        }
        newRow.leftSS = point.channelParams ? Number(point.channelParams.leftSlopeRatio ?
          point.channelParams.leftSlopeRatio : point.channelParams.LeftSlopeRatio).toFixed(0) : '';
        newRow.rightSS = point.channelParams ? Number(point.channelParams.rightSlopeRatio ?
          point.channelParams.rightSlopeRatio : point.channelParams.RightSlopeRatio).toFixed(0) : '';
        newRow.bottomWidth = point.channelParams ? Number(point.channelParams.minBedWidth ?
          point.channelParams.minBedWidth : point.channelParams.MinBedWidth).toFixed(0) : '';
        newRow.offset1 = point.channelParams ? Number(point.channelParams.offset1 ?
          point.channelParams.offset1 : point.channelParams.Offset1).toFixed(0) : '';
        newRow.offset2 = point.channelParams ? Number(point.channelParams.offset2 ?
          point.channelParams.offset2 : point.channelParams.Offset2).toFixed(0) : '';
        newRow.offset3 = point.channelParams ? Number(point.channelParams.offset3 ?
          point.channelParams.offset3 : point.channelParams.Offset3).toFixed(0) : '';
        newRow.runoffQ = Number(point.simFlowQ).toFixed(1);
        newRow.addedQ = Number(point.addedQ).toFixed(1);
        newRow.totalQ = Number(point.totalQ).toFixed(1);
        newRow.flowDepthFB = Number(point.simDepth).toFixed(1);
        newRow.flowTopWidth = Number(point.simWidth).toFixed(1);
        newRow.soilStrength = point.soilStrength ? point.soilStrength : '';
        newRow.vegCover = point.vegetalCover ? point.vegetalCover : '';
        newRow.stability = point.stability ? point.stability : '';
        newRow.capacity = point.capacity ? point.capacity : '';
        newRow.stabVelocity = point.stabVelocity ? point.stabVelocity : '';
        newRow.capaVelocity = point.capaVelocity ? point.capaVelocity : '';

        stations.push(newRow);
      })
      // this.broadcastGuardrails(startGuardrail, endGuardrail);
      stations.splice(0, 1);
      this.currentObject.waterwayDesignStations = stations;
      waterwayDesignStore.waterwayStationsEditingClone = JSON.parse(JSON.stringify(stations));
      this.waterwayStore.originalFlowDepthFBObject = this.currentObject.waterwayDesignStations.reduce((acc, station) => {
        acc[station.reachId] = station.simDepth;
        return acc;
      }, {});
      await (this.hub.ProfileStore as DynamicWaterwayProfileStore).createReachLineFromSavedWaterway();
    }

    // Clone object after digitizing reaches
    waterwayDesignStore.wdtGroupsOriginals = [];
    waterwayDesignStore.wdtGroupsOriginals.push(
      {
        groupCount: 0,
        currentObject: JSON.parse(JSON.stringify(waterwayDesignStore.waterwayDesignObject))
      }
    );
    designStore.setLoader('');
  }

  protected async insertRows(dataPoint: XyzPoint, vertexIndex: number, keyCode: ProfileKeyCode, addWDTEdits?: any) {
    const stations = this.currentObject.waterwayDesignStations;
    const originalStations = JSON.parse(JSON.stringify(stations));

    // Find the index of 'R-0' in the stations array
    const r0Index = stations.findIndex(station => station.reachId === 'R-0');

    // Adjust the vertexIndex by the index of 'R-0'
    vertexIndex += r0Index;
    stations[vertexIndex].status = "IN PROGRESS";
    stations[vertexIndex].addedQ = "";
    stations[vertexIndex].flowDepthFB = "";
    stations[vertexIndex].flowTopWidth = "";

    if (vertexIndex < 0 || vertexIndex >= stations.length) {
      return;
    }

    const formattedStationX = formatStationString(dataPoint.getX().toFixed(1));
    const formattedStationY = dataPoint.getY().toFixed(1);

    // Calculate groundZ for current reach
    const payload = {
      alignedElementDesignParametersId: this.currentObject.alignedElementDesignParametersId,
      reachStationDistance: parseFloat(dataPoint.getX().toFixed(1)) // new station x value
    };

    const response = await ProfileController.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(payload);

    let groundZ = 0;
    let cutFill = 0;

    // cutFill: channelZ - groundZ
    if (response.data && response.data.groundElevation !== undefined) {
      groundZ = parseFloat(response.data.groundElevation.toFixed(1));
      cutFill = parseFloat((parseFloat(formattedStationY) - groundZ).toFixed(1));
    }

    const newRow = {
      ...stations[vertexIndex - 1], // copy all properties from the original station
      startStation: stations[vertexIndex - 1].endStation,
      endStation: formattedStationX,
      station: formattedStationX,
      channelZ: formattedStationY,
      channelElev: formattedStationY,
      groundZ: groundZ,
      cutFill: cutFill,
      reachId: `R-${vertexIndex - r0Index}`,
      status: "IN PROGRESS",
      addedQ: "",
      flowDepthFB: "",
      flowTopWidth: ""
    };

    // Calculate stationLength and grade for the new row
    const prevStation = stations[vertexIndex - 1];
    if (prevStation.reachId !== "START") {
      const deltaCurY = parseFloat(prevStation.channelZ) - parseFloat(newRow.channelZ);
      const deltaCurX = this.constructWaterwayStation(prevStation.station) - this.constructWaterwayStation(newRow.station);
      if (deltaCurX !== 0) {
        newRow.grade = Math.abs(deltaCurY / deltaCurX);
        newRow.stationLength = Math.abs(deltaCurX);
      }
    }

    const stationsInsertedAndUpdated: any = [];
    stations.splice(vertexIndex, 0, newRow);
    stationsInsertedAndUpdated.push(newRow);

    // Update reachId, startStation, groundZ, cutFill, stationLength, and grade for the rows after the inserted row
    for (let index = vertexIndex + 1; index < stations.length; index++) {
      if (stations[index].reachId !== "END" && stations[index].reachId !== "START" && stations[index].reachId !== "R-0") {
        // Update Status
        stations[index].status = 'IN PROGRESS'
        const reachIdNumber = parseInt(stations[index].reachId.split('-')[1]);
        stations[index].reachId = `R-${reachIdNumber + 1}`;
        stations[index].startStation = stations[index - 1].endStation;

        if (index === vertexIndex + 1 || index === stations.length - 1) {
          // Recalculate groundZ and cutFill
          const payload = {
            alignedElementDesignParametersId: this.currentObject.alignedElementDesignParametersId,
            reachStationDistance: parseFloat(stations[index].station) // station x value of the current row
          };

          const response = await ProfileController.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(payload);

          if (response.data && response.data.groundElevation !== undefined) {
            stations[index].groundZ = parseFloat(response.data.groundElevation.toFixed(1));
            stations[index].cutFill = parseFloat((parseFloat(stations[index].channelZ) - stations[index].groundZ).toFixed(1));
          }

          // Recalculate stationLength and grade
          const prevStation = stations[index - 1];
          if (prevStation.reachId !== "START") {
            const deltaCurY = parseFloat(prevStation.channelZ) - parseFloat(stations[index].channelZ);
            const deltaCurX = this.constructWaterwayStation(prevStation.station) - this.constructWaterwayStation(stations[index].station);
            if (deltaCurX !== 0) {
              stations[index].grade = Math.abs(deltaCurY / deltaCurX);
              stations[index].stationLength = Math.abs(deltaCurX);
            }
          }
        }
      }
      // Only push the station into the array if its reachId is not "END"
      if (stations[index].reachId !== "END") {
        stationsInsertedAndUpdated.push(stations[index]); // Push each updated station into the array
      }
    }

    const allInsertedWaterwayVertexData = new Map();
    stationsInsertedAndUpdated.forEach((updatedStation, index) => {
      if (!updatedStation.station || !updatedStation.channelZ) {
        return;
      }
      const updatedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(updatedStation, waterwayDesignStore.channelControl)
      // station ~ endStation in DTO
      // channelZ ~ channelElev in DTO
      const originalStation = originalStations.find(os => os.station === updatedStationDTO.endStation && parseFloat(os.channelZ) === updatedStationDTO.channelElev);
      if (!originalStation) {
        allInsertedWaterwayVertexData.set("Add", updatedStationDTO);
      } else if (originalStation.reachId !== updatedStationDTO.reachId) {
        allInsertedWaterwayVertexData.set(originalStation.reachId, updatedStationDTO);
      }
    });
    const validationErrorOccurred = await WaterwayDesignVM.stationFieldValidation(stations);
    if (!validationErrorOccurred) {
      waterwayDesignStore.waterwayDesignObject.waterwayDesignStations = stations;
      await addWDTEdits(allInsertedWaterwayVertexData, false, true);
    }

    //Send all the updated values to PEM at once
    (this.hub.ProfileStore as DynamicWaterwayProfileStore).createReachLineFromSavedWaterway();

  }
  public async modifyRows(dataPoint: XyzPoint, vertexIndex: number, addWDTEdits?: any, storeEdits?: boolean): Promise<Map<any, any> | void> {
    waterwayDesignStore.startGradeNegative = false;
    waterwayDesignStore.endGradeNegative = false;
    const stations = this.currentObject.waterwayDesignStations;
    if (vertexIndex < 0 || stations.length <= vertexIndex) {
      return;
    }
    for (const [index, station] of stations.entries()) {
      if (index === vertexIndex + 1) {
        // ai design experimental code
        /* istanbul ignore if */
        if (designStore.shouldHumanFeedbackOn) {
          this.humanFeedbackData.push({ nodeId: vertexIndex, distanceAdjustment: dataPoint.getX() - Number(station.station.replace("+", "")), elevationAdjustment: dataPoint.getY() - station.channelZ });

          /* istanbul ignore if */
          if (this.humanFeedbackData.length >= 5) {
            alert("Please save the 5 operations so far for the AI training before proceeding.");
          }
        }

        // Update Current Reach values
        const formattedCurStationX = formatStationString(dataPoint.getX().toFixed(1));
        const formattedCurStationY = dataPoint.getY().toFixed(1);

        station.station = formattedCurStationX;
        station.endStation = formattedCurStationX;
        station.channelZ = formattedCurStationY;
        if (station.reachId !== 'START' && station.reachId !== 'END' && station.reachId !== 'R-0') station.status = "IN PROGRESS";

        // Update Next Reach values
        if (stations[index + 1] && stations[index + 1].reachId !== "END" && stations[index + 1].reachId !== 'R-0') {
          stations[index + 1].startStation = formattedCurStationX;
          stations[index + 1].status = "IN PROGRESS";
        }

        //calculate grounZ for current reach
        const payload = {
          alignedElementDesignParametersId: this.currentObject.alignedElementDesignParametersId,
          reachStationDistance: parseFloat(dataPoint.getX().toFixed(1))
        };
        const response = await ProfileController.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(payload);
        //cutFill: groundZ - channelZ
        if (response.data && response.data.groundElevation !== undefined) {
          station.groundZ = parseFloat(response.data.groundElevation.toFixed(1));
          station.cutFill = parseFloat((parseFloat(station.channelZ) - station.groundZ).toFixed(1));
        }

        //calcuate slope of current Reach
        const prevStation = stations[index - 1];
        if (prevStation.reachId !== "START") {
          const deltaCurY = prevStation.channelZ - station.channelZ;
          const deltaCurX = this.constructWaterwayStation(prevStation.station) - this.constructWaterwayStation(station.station);
          if (deltaCurX !== 0) {
            station.grade = Math.abs(deltaCurY / deltaCurX);
            station.stationLength = Math.abs(deltaCurX);
          }
        }

        //calcuate slope of next Reach
        const nextStation = stations[index + 1];
        if (nextStation.reachId !== "END") {
          const deltaNextY = nextStation.channelZ - station.channelZ;
          const deltaNextX = this.constructWaterwayStation(nextStation.station) - this.constructWaterwayStation(station.station);
          if (deltaNextX !== 0) {
            nextStation.grade = Math.abs(deltaNextY / deltaNextX);
            nextStation.stationLength = Math.abs(deltaNextX);
          }
        }
        const movedWaterwayVertexData = new Map();
        for (const item of stations) {
          if (item.reachId === 'START') {
            if (waterwayDesignStore.waterwayDesignObject.startGradeLength > 0) {
              const updatedStart = await this.calculateNewStartOrEndReach(0, stations);
              const updatedStartStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(updatedStart, waterwayDesignStore.channelControl)
              movedWaterwayVertexData.set(item.reachId, updatedStartStationDTO);
            }
          } else if (item.reachId === 'END') {
            if (waterwayDesignStore.waterwayDesignObject.endGradeLength > 0) {
              const updatedEnd = await this.calculateNewStartOrEndReach(stations.length - 1, stations);
              const updatedEndStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(updatedEnd, waterwayDesignStore.channelControl)
              movedWaterwayVertexData.set(item.reachId, updatedEndStationDTO);
            }
          } else {
            const moveStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(item, waterwayDesignStore.channelControl)
            movedWaterwayVertexData.set(item.reachId, moveStationDTO);
          }
        }
        if (!storeEdits) {
          waterwayDesignStore.waterwayDesignObject.waterwayDesignStations = stations;
          await addWDTEdits(movedWaterwayVertexData, false, true);
        }
        else return movedWaterwayVertexData;
        (this.hub.ProfileStore as DynamicWaterwayProfileStore).createReachLineFromSavedWaterway();
      }
    }
    this.checkSlopeDirection(stations);
  }

  public async calculateNewStartOrEndReach(index, stations, calculateGrade = true) {
    const station = stations[index];

    let stationDistance: string;
    let adjacentStation;
    let length: number;
    if ((index === 0 && waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength > 0) || (index === stations.length - 1 && waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength > 0)) {
      if (index === 0) {
        adjacentStation = stations[1];
        const formattedStation = parseFloat(adjacentStation.station.replace("+", ""));
        length = Number(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[0].stationLength);
        stationDistance = (Number(formattedStation) - length).toFixed(1);
        station.endStation = adjacentStation.station;
        station.station = station.endStation;
        station.startStation = formatStationString(stationDistance);
      } else {
        adjacentStation = stations[stations.length - 2];
        const formattedStation = (parseFloat(adjacentStation.station.replace("+", "")));
        length = Number(waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength);
        stationDistance = Number((formattedStation + length)).toFixed(1);
        station.startStation = adjacentStation.station;
        station.endStation = formatStationString(stationDistance);
        station.station = station.endStation;
      }

      const payload = {
        alignedElementDesignParametersId: this.currentObject.alignedElementDesignParametersId,
        reachStationDistance: parseFloat(stationDistance)
      };
      const response = await ProfileController.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(payload);
      if (response.data && response.data.groundElevation !== undefined) {
        station.groundZ = parseFloat(response.data.groundElevation.toFixed(1));
        station.channelZ = station.groundZ;
      }

      station.stationLength = Number(length).toFixed(1);
      if (!waterwayDesignStore.gradeEdited &&
        !waterwayDesignStore.stationLengthEdited &&
        !waterwayDesignStore.channelStartGradeLengthChangedGlobal &&
        !waterwayDesignStore.channelEndGradeLengthChangedGlobal) {
        station.grade = (Math.abs(adjacentStation.channelZ - station.groundZ) / length);
        station.grade = (station.grade * 100).toFixed(2);
      }
    } else {
      station.endStation = '';
      station.startStation = '';
      station.groundZ = '0.0';
      station.channelZ = '0.0';
      station.stationLength = '0.0';
      station.grade = 0;
    }

    return station;
  }

  public validateStationInput(event: any): boolean {
    // If the value hasn't changed, return false immediately.
    let isValid = false;
    if (event.target.value === "") {
      return false;
    }

    // Test if the input value is a valid station (e.g., '123', '1+23')
    if (event.target.name === "station" && /^(\d+\+\d+|\d+)(\.\d+)?$/.test(event.target.value)) {
      isValid = true;
    }

    //Test if value is a valid channelZ number (e.g., '123', '123.45', etc, no negative numbers)
    if (event.target.name === "channelZ" && /^\d+(\.\d+)?$/.test(event.target.value)) {
      isValid = true;
    }

    if (event.target.name === "addedQ" && /^\d+(\.\d+)?$/.test(event.target.value)) {
      isValid = true;
    }

    return isValid;
  }

  // ai design experimental code
  /* istanbul ignore next */
  getHumanFeedbackPayload() {
    const payload = {
      alignedElementDesignParamsId: this.currentObject.alignedElementDesignParametersId,
      nodeActions: this.humanFeedbackData.slice(0, 5),
    };
    return payload;
  }

  /* istanbul ignore next */
  async addAiRows(stationsData: { reachId: string; station: number; channelElev: number }[]) {
    designStore.setLoader('Adding reaches...');
    const alignedElementDesignParamsId = Number(waterwayDesignStore.alignedDesignElementId);
    const stationVertices = {};
    stationsData.forEach((point) => {
      stationVertices[point.station] = point.channelElev;
    });
    const data = (await designController.createDefaultReachesUsingPOST({ alignedElementDesignParamsId, stationVertices })).data;

    // if (data.status === 'wdt_124') {
    //     await MessageCenter.addErrorFromCode('WDT_124');
    // } else if (data.status === 'wdt_123') {
    //     await MessageCenter.addWarningFromCode('WDT_123');
    // }
    // const stations = this.currentObject.waterwayDesignStations;
    const stations = [{ ...this.initialWaterwayDesignStation }];
    // let startGuardrail = 0;
    // let endGuardrail = 0;
    if (data.waterwayVertexParamDTOList) {
      data.waterwayVertexParamDTOList.forEach((point, idx) => {
        const newRow = { ...this.initialWaterwayDesignStation, ...point };

        if (point.reachId !== 'START' && point.reachId !== 'END' && point.reachId !== 'R-0') {
          newRow.status = 'IN PROGRESS'
        } else {
          newRow.status = point.status
          // if (point.reachId == 'START') {
          //   startGuardrail = Number(point.endStation?.replace('+', ''));
          // };
          // if (point.reachId == 'END') {
          //   endGuardrail = Number(point.endStation?.replace('+', ''));
          // };

        }

        newRow.reachId = point.reachId ? point.reachId : '';
        if (point.startStation) {
          const index = point.startStation.indexOf('.');
          // newRow.startStation = index >= 0 ? point.startStation.slice(0, index) : point.startStation;
          newRow.startStation = point.startStation;
        } else {
          newRow.startStation = '';
        }
        if (point.endStation) {
          const index = point.endStation.indexOf('.');
          // newRow.endStation = index >= 0 ? point.endStation.slice(0, index) : point.endStation;
          // newRow.station = index >= 0 ? point.endStation.slice(0, index) : point.endStation;
          newRow.endStation = point.endStation;
          newRow.station = point.endStation;

          // const distance = point.endStation.replace('+', '');
          // let roundedDistance: number;
          // if (idx == 1) {
          //   roundedDistance = Math.ceil(Number(distance));
          // } else if (idx = data.waterwayVertexParamDTOList?.length! - 2) {
          //   roundedDistance = Math.floor(Number(distance));
          // } else {
          //   roundedDistance = Math.round(Number(distance));
          // }
          // const station = (Math.floor(roundedDistance / 100)).toFixed(0) + '+' + roundedDistance.toString().slice(-2);
          // newRow.endStation = station;
          // newRow.station = station;
        } else {
          newRow.endStation = '';
          newRow.station = '';
        }
        newRow.groundZ = Number(point.groundElev).toFixed(1);
        newRow.channelZ = Number(point.channelElev).toFixed(1);
        newRow.cutFill = Number(point.cutFill).toFixed(1);
        newRow.stationLength = Number(point.stationDist);
        if (point.reachId === 'START' || point.reachId === 'END') {
          newRow.grade = point.grade !== undefined ? (point.grade * 100).toFixed(2) : point.grade;
        } else {
          newRow.grade = point.grade;
        }
        newRow.leftSS = point.channelParams ? Number(point.channelParams.leftSlopeRatio ?
          point.channelParams.leftSlopeRatio : point.channelParams.LeftSlopeRatio).toFixed(0) : '';
        newRow.rightSS = point.channelParams ? Number(point.channelParams.rightSlopeRatio ?
          point.channelParams.rightSlopeRatio : point.channelParams.RightSlopeRatio).toFixed(0) : '';
        newRow.bottomWidth = point.channelParams ? Number(point.channelParams.minBedWidth ?
          point.channelParams.minBedWidth : point.channelParams.MinBedWidth).toFixed(0) : '';
        newRow.offset1 = point.channelParams ? Number(point.channelParams.offset1 ?
          point.channelParams.offset1 : point.channelParams.Offset1).toFixed(0) : '';
        newRow.offset2 = point.channelParams ? Number(point.channelParams.offset2 ?
          point.channelParams.offset2 : point.channelParams.Offset2).toFixed(0) : '';
        newRow.offset3 = point.channelParams ? Number(point.channelParams.offset3 ?
          point.channelParams.offset3 : point.channelParams.Offset3).toFixed(0) : '';
        newRow.runoffQ = Number(point.simFlowQ).toFixed(1);
        newRow.addedQ = Number(point.addedQ).toFixed(1);
        newRow.totalQ = Number(point.totalQ).toFixed(1);
        newRow.flowDepthFB = Number(point.simDepth).toFixed(1);
        newRow.flowTopWidth = Number(point.simWidth).toFixed(1);
        newRow.soilStrength = point.soilStrength ? point.soilStrength : '';
        newRow.vegCover = point.vegetalCover ? point.vegetalCover : '';
        newRow.stability = point.stability ? point.stability : '';
        newRow.capacity = point.capacity ? point.capacity : '';
        newRow.stabVelocity = point.stabVelocity ? point.stabVelocity : '';
        newRow.capaVelocity = point.capaVelocity ? point.capaVelocity : '';

        stations.push(newRow);
      })
      // this.broadcastGuardrails(startGuardrail, endGuardrail);
      stations.splice(0, 1);
      this.currentObject.waterwayDesignStations = stations;
      waterwayDesignStore.waterwayStationsEditingClone = JSON.parse(JSON.stringify(stations));
      this.waterwayStore.originalFlowDepthFBObject = this.currentObject.waterwayDesignStations.reduce((acc, station) => {
        acc[station.reachId] = station.simDepth;
        return acc;
      }, {});
      await (this.hub.ProfileStore as DynamicWaterwayProfileStore).createReachLineFromSavedWaterway();
    }

    // Clone object after digitizing reaches
    waterwayDesignStore.wdtGroupsOriginals = [];
    waterwayDesignStore.wdtGroupsOriginals.push(
      {
        groupCount: 0,
        currentObject: JSON.parse(JSON.stringify(waterwayDesignStore.waterwayDesignObject))
      }
    );
    designStore.setLoader('');
  }
  //End: ai design experimental code
}

export { DynamicWaterwayTableStore };
